export const readId = (state) => state.id;
export const readFilter = (state) => state.filter;
export const readRegions = (state) => state.regions;
export const readRegion = (state) => state.region;
export const readError = (state) => state.error;
